import React, { useState } from "react";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";

const OnderhoudstaakToevoegen = () => {
  const [omschrijving, setOmschrijving] = useState("");
  const [kosten, setKosten] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const request = await axiosInstance.post(`onderhoudstaken/`, {
        omschrijving: omschrijving,
        kosten: kosten,
      }).then(response=>{
        try{
          if(response.response.status==403){
            alert("Forbidden! You do not have permission to perform this action.");
            return (window.location = "/app/");
          } else {
            alert("Bewerking voltooid!");
            return (window.location = "/app/");
          };
        } catch(e){
          alert("Bewerking voltooid!");
          return (window.location = "/app/");
          console.log("operation seems successfull, known error",e);
        }
      });
      return (window.location = "/app/onderhoudstaken");
    } catch (e) {
      return alert(`Error-omschrijving: ${e}`);
    }
  };

  return (
    <section className="section">
      <div className="container box" style={{ width: "50%" }}>
        <h1 className="title is-2">Onderhoudstaak toevoegen</h1>
        <div className="field">
          <label className="label">Omschrijving</label>
          <div className="control has-icons-left">
            <input
              name="plaats"
              className="input"
              type="text"
              placeholder="Omschrijving"
              defaultValue={omschrijving}
              onChange={(e) => setOmschrijving(e.target.value)}
            />
            <span className="icon is-small is-left">
              <i class="far fa-file-alt"></i>
            </span>
          </div>
        </div>
        <div className="field">
          <label className="label">Kosten</label>
          <div className="control has-icons-left">
            <input
              name="plaats"
              className="input"
              type="number"
              placeholder="Kosten"
              defaultValue={kosten}
              onChange={(e) => setKosten(e.target.value)}
            />
            <span className="icon is-small is-left">
              <i class="fas fa-money-check-alt"></i>
            </span>
          </div>
        </div>
        <div className="field is-grouped">
          <div className="control">
            <button
              onClick={handleSubmit}
              className="button is-primary is-outlined is-small"
            >
              <i class="far fa-save"></i>
              Opslaan
            </button>
          </div>
          <div className="control">
            <button
              onClick={() => (window.location = `/app/onderhoudstaken/`)}
              className="button is-danger is-outlined is-small"
            >
              <i class="fas fa-ban"></i>
              Annuleren
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnderhoudstaakToevoegen;
